import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getTypeTags } from '../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader.js'
import { write, utils } from 'xlsx'
import { withTranslation } from 'react-i18next'
import Select from 'react-select'
import moment from 'moment'

class PortAdminEventReports extends React.Component {
  state = {
    Data: [],
    eventList: [],
    eventId: null,
    bookingStatus: '',
    typeTag: '',
    reportUrl: '',
    isSearching: false,

    from: moment().subtract(3, 'd').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
    minToDate: moment().subtract(3, 'd').format('YYYY-MM-DD'),
    maxToDate: moment().format('YYYY-MM-DD'),
    minFromDate: moment().subtract(3, 'd').format('YYYY-MM-DD'),
    maxFromDate: moment().format('YYYY-MM-DD'),
  }

  componentDidMount() {
    this.eventList()
    this.detailsSummary()
  }

  clearSearch = async () => {
    this.setState({
      Data: [],
    })
  }

  detailsSummary = async () => {
    if (this.state.from > this.state.to) {
      Swal.fire(`${this.props.t('invalidDate')}`, '', 'error')
      return
    }
    this.setState({
      isSearching: true,
    })
    await axios
      .get(Constant.getAPI() + `/reports/port-admin/event-report`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
          'accept-lang': `${localStorage.getItem('selectedLanguage')}`,
        },
        params: {
          eventId: this.state?.eventId?.value || '',
          status: this.state.bookingStatus,
          typeTag: this.state.typeTag,
          from: this.state.from,
          to: this.state.to,
        },
      })
      .then((response) => {
        this.setState({
          Data: response?.data?.data?.data,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.message || err?.response?.data?.data,
          icon: 'error',
          text: err?.response?.data?.data?.details?.[0]?.message,
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  download = () => {
    let link = Constant.getImage() + this.state.reportUrl
    window.location.href = link
  }

  handleChange = (event) => {
    event.persist()

    this.setState({
      [event?.target?.name]: event?.target?.value,
    })
  }

  convertDurationToArabic = (duration) => {
    if (!duration) return '--'

    // Convert "X Hr" or "X Hrs" format
    const match = duration.match(/(\d+)\s*(Hr|Hrs)/)
    if (match) {
      const hours = match[1]
      const hoursInArabic = hours.toString().replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d])
      return hours === '1' ? `${hoursInArabic} ساعة` : `${hoursInArabic} ساعات`
    }
    return duration
  }

  convertTypeTagToArabic = (typeTag) => {
    const typeTagMap = {
      Hourly: 'بالساعة',
      Daily: 'يومي',
      Weekly: 'أسبوعي',
      Monthly: 'شهري',
    }
    return typeTagMap[typeTag] || typeTag
  }

  getStatusTranslation = (status, isArabic) => {
    const statusTranslations = {
      Confirmed: 'مؤكد',
      Cancelled: 'ملغي',
      Successful: 'ناجح',
      Pending: 'قيد الانتظار',
      Postponed: 'مؤجل',
      Sailed: 'تم الإبحار',
      'Booking Cancel': 'إلغاء الحجز',
    }

    return isArabic ? statusTranslations[status] || status : status
  }

  eventList = async () => {
    await axios
      .get(Constant.getAPI() + '/event/list-events', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: localStorage.getItem('countryShortName'),
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            eventList: res.data.data.map((itm) => ({
              label: `${itm.event_name_en}/${itm.event_name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleEventChange = (event) => {
    this.setState({
      eventId: event,
    })
  }

  handleClear = () => {
    this.setState({ eventId: null })
  }

  clearFilters = () => {
    this.setState(
      {
        eventId: null,
        typeTag: '',
        bookingStatus: '',
        Data: [],
      },
      () => {
        this.detailsSummary()
      }
    )
  }

  render() {
    const currentLanguage = localStorage.getItem('selectedLanguage') || 'en'
    const isArabic = currentLanguage === 'ar'
    const textAlign = isArabic ? 'right' : 'left'
    const tableDirection = isArabic ? 'rtl' : 'ltr'

    let columns = [
      {
        name: 'order_number',
        label: this.props.t('Order Number'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: currentLanguage === 'en' ? 'event_name_en' : 'event_name_ar',
        label: this.props.t('eventName'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: currentLanguage === 'en' ? 'customer_name' : 'customer_name_ar',
        label: this.props.t('Customer Name'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: 'booking_date',
        label: this.props.t('Booking Date'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: 'start_time',
        label: this.props.t('Start Time'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: 'end_time',
        label: this.props.t('End Time'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: 'booking_status',
        label: this.props.t('Booking Status'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            let statusStyle = {}
            const displayValue = this.getStatusTranslation(value, isArabic)

            if (value === 'Cancelled' || value === 'Booking Cancel' || value === 'إلغاء الحجز' || value === 'ملغي') {
              statusStyle = { backgroundColor: 'red', color: 'white', fontWeight: 'bold' }
            } else if (value === 'Postponed' || value === 'قيد الانتظار') {
              statusStyle = { backgroundColor: '#f4c2c2', color: 'black', fontWeight: 'bold' }
            } else if (value === 'Confirmed' || value === 'مؤكد') {
              statusStyle = { backgroundColor: '#98fb98', color: 'black', fontWeight: 'bold' }
            } else if (value === 'Pending' || value === 'قيد الانتظار') {
              statusStyle = { backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }
            } else if (value === 'Sailed' || value === 'تم الإبحار') {
              statusStyle = { backgroundColor: '#00bfff', color: 'white', fontWeight: 'bold' }
            } else if (value === 'Successful' || value === 'ناجح') {
              statusStyle = { backgroundColor: '#0ac282', color: 'black', fontWeight: 'bold' }
            } else {
              statusStyle = { backgroundColor: 'gray', color: 'white', fontWeight: 'bold' }
            }
            return value ? (
              <div style={{ textAlign }}>
                <span
                  className="badge badge-pill"
                  style={statusStyle}
                >
                  {displayValue}
                </span>
              </div>
            ) : (
              '--'
            )
          },
        },
      },
      {
        name: 'type_tag',
        label: this.props.t('Type Tag'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            const displayValue = isArabic ? this.convertTypeTagToArabic(value) : value
            return value ? <div style={{ textWrap: 'nowrap', textAlign }}>{displayValue}</div> : '--'
          },
        },
      },
    ]

    const options = {
      filter: false,
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      responsive: 'standard',
      selectableRows: 'none',
      fixedHeader: true,
      elevation: 0,
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 25, 50],
      downloadOptions: {
        filename: this.props.t('Event Report'),
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = this.props.t('Event Report')

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            temp[columns[idx].label] = v
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        return false
      },
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? (
            <Loader open={this.state.isSearching} />
          ) : (
            this.props.t('Sorry, No data Found')
          ),
          toolTip: this.props.t('Sort'),
          columnHeaderTooltip: (column) => `${this.props.t('Sort for')} ${column.label}`,
        },
        pagination: {
          next: this.props.t('Next'),
          previous: this.props.t('Previous'),
          rowsPerPage: this.props.t('Rows per page:'),
          displayRows: this.props.t('of'),
        },
      },
      setTableProps: () => ({
        style: {
          direction: tableDirection,
          tableLayout: 'auto',
          width: '100%',
        },
      }),
      setHeadCellProps: () => ({
        style: {
          textAlign,
          paddingRight: isArabic ? '24px' : '10px',
          paddingLeft: isArabic ? '10px' : '24px',
          backgroundColor: '#f5f5f5',
          whiteSpace: 'nowrap',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign,
          paddingRight: isArabic ? '24px' : '10px',
          paddingLeft: isArabic ? '10px' : '24px',
          whiteSpace: 'nowrap',
        },
      }),
    }

    return (
      <div
        className="pcoded-inner-content"
        dir={isArabic ? 'rtl' : 'ltr'}
      >
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.t('dailyEventReport')}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div
                    className="page-header-breadcrumb"
                    style={{ float: isArabic ? 'left' : 'right' }}
                  >
                    <ul
                      className="breadcrumb-title"
                      style={{ flexDirection: isArabic ? 'row-reverse' : 'row' }}
                    >
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.t('dailyEventReport')}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">{this.props.t('eventName')}</label>
                            <div className="col-sm-9">
                              <Select
                                name="eventId"
                                value={this.state.eventId}
                                onChange={this.handleEventChange}
                                options={this.state.eventList}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.handleClear}
                                placeholder={this.props.t('selectOptions')}
                                styles={{
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                    position: 'absolute',
                                    width: '100%',
                                  }),
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-md-3 col-form-label">{this.props.t('fromDate')}</label>
                            <div className="col-md-9">
                              <input
                                type="date"
                                id="from"
                                className="form-control"
                                value={this.state?.from}
                                name="from"
                                onChange={this.handleChange}
                                min={this.state.minFromDate}
                                max={this.state.maxFromDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-md-3 col-form-label">{this.props.t('toDate')}</label>
                            <div className="col-md-9">
                              <input
                                type="date"
                                id="to"
                                className="form-control"
                                value={this.state?.to}
                                name="to"
                                onChange={this.handleChange}
                                min={this.state.minToDate}
                                max={this.state.maxToDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-3 col-form-label">{this.props.t('bookingStatus')}</label>
                            <div className="col-9">
                              <select
                                name="bookingStatus"
                                className="form-control"
                                value={this.state.bookingStatus}
                                onChange={this.handleChange}
                              >
                                <option value={''}>{this.props.t('all')}</option>
                                <option value={'Pending'}>{this.props.t('Pending')}</option>
                                <option value={'Successful'}>{this.props.t('Successful')}</option>
                                <option value={'Cancelled'}>{this.props.t('Cancelled')}</option>
                                <option value={'Confirmed'}>{this.props.t('Confirmed')}</option>
                                <option value={'Postponed'}>{this.props.t('Postponed')}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">{this.props.t('typeTag')}</label>
                            <div className="col-sm-9">
                              <select
                                name="typeTag"
                                className="form-control"
                                value={this.state.typeTag}
                                onChange={this.handleChange}
                              >
                                <option value={''}>{this.props.t('all')}</option>
                                {getTypeTags().map((itm) => (
                                  <option
                                    value={itm}
                                    key={itm}
                                  >
                                    {this.props.t(itm)}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="col-12"
                              style={{ color: 'red' }}
                            >
                              {this.props.t('maxData')}
                            </div>
                            <div className="col-12 mt-2">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-sm btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  {this.props.t('searching')}
                                </button>
                              ) : (
                                <button
                                  style={{ width: 150 }}
                                  onClick={this.detailsSummary}
                                  className="btn btn-sm btn-inverse waves-effect"
                                >
                                  {this.props.t('search')}
                                </button>
                              )}
                              <button
                                style={{ width: 150, marginLeft: 10 }}
                                onClick={this.clearFilters}
                                className="btn btn-sm btn-inverse waves-effect"
                              >
                                {this.props.t('clear')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card card-border-default">
                    <div
                      className="card-block"
                      style={{ padding: '0' }}
                    >
                      <div style={{ width: '100%', overflowX: 'auto', maxWidth: '100%' }}>
                        <MUIDataTable
                          // title={<div style={{ textAlign }}>{this.props.t('dailyEventReport')}</div>}
                          data={this.state.Data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(PortAdminEventReports)
